module.exports = __webpack_public_path__ + "static/media/logoCamaraComercioFooter.00dd48fa.jpg";